import { render, staticRenderFns } from "./LeadlikeTableLocation.vue?vue&type=template&id=21f97d1f&"
import script from "./LeadlikeTableLocation.vue?vue&type=script&lang=js&"
export * from "./LeadlikeTableLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports